export type PobierzToken = (wymusOdswiezenie: boolean) => Promise<string>;

function zTokenem(init: RequestInit, token: string): RequestInit {
  const naglowki = new Headers(init.headers);
  naglowki.set('Authorization', `Bearer ${token}`);
  return { ...init, headers: naglowki };
}

function odmowaDostepu(status: number): boolean {
  return status === 401 || status === 403;
}

export async function wywolajZTokenem(
  adres: string,
  init: RequestInit,
  pobierzToken: PobierzToken,
  wyslij: typeof fetch = fetch,
): Promise<Response> {
  const odpowiedz = await wyslij(adres, zTokenem(init, await pobierzToken(false)));
  if (!odmowaDostepu(odpowiedz.status)) {
    return odpowiedz;
  }
  return wyslij(adres, zTokenem(init, await pobierzToken(true)));
}
